module.exports = "/images/logo.svg?f9af4ee8b27f27d234a1103157f46080";